// src/data/journals.js
const journals = [
  {
    title: "Overthinking Detox",
    price: "₹19",
    image: "images/journals/Overthinking.png",
    summary: "Break free from mental loops and gently declutter your thoughts.",
    storagePath: "overthinking_detox.pdf",
  },
  {
    title: "Breakup Closure",
    price: "₹29",
    image: "images/journals/breakup_closure.png",
    summary: "Let go with grace, heal heartbreak, and reclaim your peace.",
    storagePath: "breakup_closure.pdf",
  },
  {
    title: "Anxiety Release",
    price: "₹19",
    image: "images/journals/anxiety.png",
    summary: "Soothe your nervous system and ease the emotional storm.",
    storagePath: "anxiety_release.pdf",
  },
  {
    title: "Self-Love Starter",
    price: "₹29",
    image: "images/journals/self_worth.png",
    summary: "Reconnect with your worth and learn to treat yourself gently.",
    storagePath: "self_love_starter.pdf",
  },
  {
    title: "Confidence",
    price: "₹29",
    image: "images/journals/Confidence.png",
    summary: "Step into your power and stop dimming your light.",
    storagePath: "confidence.pdf",
  },
  {
    title: "Emotional Healing",
    price: "₹19",
    image: "images/journals/emotional_healing.png",
    summary: "Gently heal your past and nurture your heart forward.",
    storagePath: "emotional_healing.pdf",
  },
  {
    title: "Romantic Intimacy",
    price: "₹39",
    image: "images/journals/Romantic_Intimacy.png",
    summary: "Deepen emotional closeness and rebuild romantic trust.",
    storagePath: "romantic_intimacy.pdf",
  },
  {
    title: "Sexual Guilt",
    price: "₹29",
    image: "images/journals/sexual_guilt.png",
    summary: "Free yourself from shame, trauma, or fear around sexuality.",
    storagePath: "sexual_guilt.pdf",
  },
  {
    title: "Anger",
    price: "₹24",
    image: "images/journals/anger.png",
    summary: "Channel your anger into healing, not destruction.",
    storagePath: "anger.pdf",
  },
  {
    title: "Toxic People",
    price: "₹29",
    image: "images/journals/toxic_people.png",
    summary: "Detach peacefully from people who drain or harm you.",
    storagePath: "toxic_people.pdf",
  },
  {
    title: "Toxic Masculinity",
    price: "₹19",
    image: "images/journals/toxic_masculinity.png",
    summary: "Break free from unhealthy gender expectations and pressure.",
    storagePath: "toxic_masculinity.pdf",
  },
  {
    title: "Trust Issues",
    price: "₹29",
    image: "images/journals/trust_issues.png",
    summary: "Rebuild inner and outer trust after betrayal or fear.",
    storagePath: "trust_issues.pdf",
  },
  {
    title: "Healing Inner Child",
    price: "₹29",
    image: "images/journals/healing_inner_child.png",
    summary: "Revisit the younger you and offer safety and love.",
    storagePath: "healing_inner_child.pdf",
  },
  {
    title: "Grief and Loss",
    price: "₹29",
    image: "images/journals/grief_and_loss.png",
    summary: "Honor your pain and find space for meaning and peace.",
    storagePath: "grief_and_loss.pdf",
  },
  {
    title: "Body Image",
    price: "₹29",
    image: "images/journals/Body_Image.png",
    summary: "Reclaim how you see and speak to your body.",
    storagePath: "body_image.pdf",
  },
  {
    title: "Negative Thoughts",
    price: "₹29",
    image: "images/journals/Negative_Thoughts.png",
    summary: "Quiet the critical voice and embrace kinder self-talk.",
    storagePath: "negative_thoughts.pdf",
  },
  {
    title: "Shame",
    price: "₹29",
    image: "images/journals/shame.png",
    summary: "Release the weight of unworthiness and hidden wounds.",
    storagePath: "shame.pdf",
  },
  {
    title: "Mindfulness",
    price: "₹29",
    image: "images/journals/Mindfulness.png",
    summary: "Be present in your breath, body, and now moment.",
    storagePath: "mindfulness.pdf",
  },
  {
    title: "Sleep Struggles",
    price: "₹29",
    image: "images/journals/Sleep_Struggles.png",
    summary: "Soothe your racing mind and prepare for rest.",
    storagePath: "sleep_struggles.pdf",
  },
  {
    title: "Guilt",
    price: "₹29",
    image: "images/journals/Guilt.png",
    summary: "Free yourself from the burden of past mistakes and regret.",
    storagePath: "guilt.pdf",
  },
  {
    title: "Romantic Trauma",
    price: "₹39",
    image: "images/journals/romantic_trauma.png",
    summary: "Heal emotional wounds from past toxic or painful love.",
    storagePath: "romantic_trauma.pdf",
  },
  {
    title: "Rejection",
    price: "₹29",
    image: "images/journals/rejection.png",
    summary: "Explore and ease the sting of being left out or not chosen.",
    storagePath: "rejection.pdf",
  },
  {
    title: "Peace and Calm",
    price: "₹29",
    image: "images/journals/peace_and_calm.png",
    summary: "Ground yourself, breathe deeply, and reconnect with peace.",
    storagePath: "peace_and_calm.pdf",
  },
  {
    title: "Life Purpose",
    price: "₹29",
    image: "images/journals/Life_Purpose.png",
    summary: "Clarify your direction, dreams, and values.",
    storagePath: "life_purpose.pdf",
  },
  {
    title: "Loneliness",
    price: "₹29",
    image: "images/journals/loneliness.png",
    summary: "Sit gently with your solitude and find comfort in your own presence.",
    storagePath: "loneliness.pdf",
  },
  {
    title: "Fear of Failure",
    price: "₹29",
    image: "images/journals/Fear_of_Failure.png",
    summary: "Let go of perfectionism and grow from your setbacks.",
    storagePath: "fear_of_failure.pdf",
  },
  {
    title: "Parent Wounds",
    price: "₹19",
    image: "images/journals/parent_wounds.png",
    summary: "Face emotional wounds from your caregivers and reclaim your truth.",
    storagePath: "parent_wounds.pdf",
  },
  {
    title: "Self Doubt",
    price: "₹19",
    image: "images/journals/self_doubt.png",
    summary: "Silence the inner critic and strengthen your inner voice.",
    storagePath: "self_doubt.pdf",
  },
  {
    title: "Self Worth",
    price: "₹29",
    image: "images/journals/self_worth.png",
    summary: "Remember your value — even when others don’t see it.",
    storagePath: "self_worth.pdf",
  },
  {
    title: "Emotional Burnout",
    price: "₹29",
    image: "images/journals/emotional_burnout.png",
    summary: "Restore your energy and feel safe to pause and breathe.",
    storagePath: "emotional_burnout.pdf",
  },
  {
    title: "Heartbreak",
    price: "₹29",
    image: "images/journals/Heartbreak.png",
    summary: "Grieve your loss and hold space for your broken heart.",
    storagePath: "heartbreak.pdf",
  },
  {
    title: "Unhealed Childhood",
    price: "₹19",
    image: "images/journals/unhealed_childhood.png",
    summary: "Face the emotional wounds from your early years and reclaim your peace.",
    storagePath: "unhealed_childhood.pdf",
  },
  {
    title: "Social Anxiety",
    price: "₹29",
    image: "images/journals/social_anxiety.png",
    summary: "Ease the fear of judgment and show up as your true self.",
    storagePath: "social_anxiety.pdf",
  },
  {
    title: "Family Trauma",
    price: "₹29",
    image: "images/journals/Family_Trauma.png",
    summary: "Break generational cycles and begin a new emotional legacy.",
    storagePath: "family_trauma.pdf",
  },
  {
    title: "Relationship Patterns",
    price: "₹29",
    image: "images/journals/Relationship_Patterns.png",
    summary: "Understand your habits in love and rewrite your story.",
    storagePath: "relationship_patterns.pdf",
  },
];

export default journals;
